import Vue from 'vue'
import VueRouter from 'vue-router'


import store from '../store/index'

import Index from '../views/PC/Index.vue'

import Error from '../views/500/500.vue'
import { Message } from 'element-ui';
Vue.use(VueRouter)
let isMobileFlag = JSON.parse(localStorage.getItem('isMobileFlag'))
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
const routes = [
    {
        path: '/',
        redirect: '/login',
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/PC/login1/Login.vue')
    },
    {
        path: '/index',
        name: 'index',
        redirect: '/project',
        component: Index,
        children: [
            {
                path: isMobileFlag ? '/nav-menu' : 'mobilezhuanyong',
                name: '主页',
                component: () => import('../views/PC/Home/home.vue')
            },
            {
                path: '/project',
                name: '项目管理',
                component: () => import('../views/PC/Project/project.vue'),
                meta: {
                    index: '1-1'
                }
            },
            {
                path: '/provider',
                name: '供应商管理',
                component: () => import('../views/PC/Provider/provider.vue'),
                meta: {
                    index: '2-1'
                }
            },
            {
                path: '/up-file',
                name: '客户投标',
                component: () => import('../views/PC/UpFIle/upFile.vue'),
                meta: {
                    index: '3-1'
                }
            },
            {
                path: '/data-analyze',
                name: '数据分析',
                component: () => import('../views/PC/DataAnalyze/data-analyze.vue'),
                meta: {
                    index: '4-1'
                }
            },

            /* 采购 */
            {
                path: '/add-purchase',
                name: '采购操作',
                component: () => import('../views/PC/Purchase/add-purchase/add-purchase.vue'),
                meta: {
                    index: '5-1'
                }
            },
            {
                path: '/purchase-list',
                name: '采购列表',
                component: () => import('../views/PC/Purchase/purchase-list/purchase-list.vue'),
                meta: {
                    index: '5-2'
                }
            },
        ]
    },

    {
        path: '/500',
        name: '500',
        component: Error
    },
    {
        path: '/*',
        name: '404',
        component: () => import('../views/404/404.vue')
    },
]

const router = new VueRouter({
    mode: 'hash',
    routes
})


router.beforeEach(async (to, from, next) => {
    // to和from都是路由实例
    // to：即将跳转到的路由
    // from：现在的要离开的路由
    // next：函数
    let HAS_LOGIN = true

    // !localStorage.getItem('state') || 
    if (!localStorage.getItem('appToken')) {
        HAS_LOGIN = false
    }

    if (to.name !== 'login') {  // 非login
        if (HAS_LOGIN) {
            next()
        } else if (to.name === '客户投标') { next() }
        else {
            next({ name: 'login' })
            Message.closeAll()
            Message({ message: '登录超时', type: 'warning' })
        }
    } else {  // login
        next()
    }
})

export default router
